import { errorNotification } from './Notifications';

export const handleRequestError = (err, alert = true, route = null) => async dispatch => {
	console.error(err);
	if (alert) {
		dispatch(errorNotification(err, route));
	}
};
